// ── API client + utils ────────────────────────
const API = window.location.hostname === 'localhost' ? 'http://localhost:8300' : '/api';

export function getToken() {
  return localStorage.getItem('ejatv_token') || '';
}

export function logout() {
  localStorage.removeItem('ejatv_token');
  localStorage.removeItem('ejatv_user');
  window.location.reload();
}

// ── Toast notification system ────────────────
let _toastContainer = null;
function ensureToastContainer() {
  if (_toastContainer && document.body.contains(_toastContainer)) return _toastContainer;
  _toastContainer = document.createElement('div');
  _toastContainer.id = 'ejatv-toast';
  _toastContainer.style.cssText = 'position:fixed;top:16px;right:16px;z-index:9999;display:flex;flex-direction:column;gap:8px;pointer-events:none;';
  document.body.appendChild(_toastContainer);
  return _toastContainer;
}

export function showToast(msg, type='error') {
  const c = ensureToastContainer();
  const t = document.createElement('div');
  const colors = {error:'#991B1B',success:'#065F46',warn:'#92400E'};
  const bgs = {error:'#FEE2E2',success:'#D1FAE5',warn:'#FEF3C7'};
  const borders = {error:'#FCA5A5',success:'#6EE7B7',warn:'#FDE68A'};
  t.style.cssText = `pointer-events:auto;padding:10px 16px;border-radius:8px;font-size:13px;font-weight:500;font-family:DM Sans,system-ui,sans-serif;box-shadow:0 4px 12px rgba(0,0,0,.12);max-width:380px;color:${colors[type]||colors.error};background:${bgs[type]||bgs.error};border:1px solid ${borders[type]||borders.error};opacity:0;transform:translateX(20px);transition:all .25s ease;`;
  t.textContent = msg;
  c.appendChild(t);
  requestAnimationFrame(() => { t.style.opacity='1'; t.style.transform='translateX(0)'; });
  setTimeout(() => {
    t.style.opacity='0'; t.style.transform='translateX(20px)';
    setTimeout(() => t.remove(), 300);
  }, 4000);
}

export const api = async (path, method='GET', body=null) => {
  const headers = {'Content-Type':'application/json'};
  const token = getToken();
  if (token) headers['Authorization'] = 'Bearer ' + token;

  const r = await fetch(API+path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null
  });

  if (r.status === 401) {
    localStorage.removeItem('ejatv_token');
    showToast('Sessione scaduta — effettua di nuovo il login', 'warn');
    window.dispatchEvent(new Event('ejatv-auth-expired'));
    throw new Error('Sessione scaduta');
  }
  if (!r.ok) {
    const t = await r.text();
    let detail = t;
    try { detail = JSON.parse(t).detail || t; } catch {}
    if (method !== 'GET') showToast(detail || `Errore ${r.status}`, 'error');
    throw new Error(detail);
  }
  if (r.status === 204) return null;
  return r.json();
};

export const fmt = n => '\u20AC\u00A0'+(+(n||0)).toLocaleString('it-IT',{minimumFractionDigits:0,maximumFractionDigits:0});
export const fmtD = s => s ? s.split('T')[0].split('-').reverse().join('/') : '-';
export const dayN = s => parseInt((s||'').split('T')[0].split('-')[2], 10);
